import { PrivateBetaScreen } from './PrivateBetaScreen';

export const FileStorage = () => {
  return (
    <PrivateBetaScreen
      icon="i-heroicons:folder-open"
      title="Store and manage files"
      description="Upload, organize, and serve static assets, user uploads, and media files for your application."
    />
  );
};
